import React from 'react';

import { Tooltip } from '@/components/Tooltip';

export interface QueryShortestProps {
  value: number | undefined;
  editable: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export function QueryShortest({
  value,
  editable,
  onChange,
}: QueryShortestProps) {
  const tooltipContent =
    'Retrieve only the n-shortest paths. If multiple paths are tied for n-shortest, all tied paths will be returned.';

  if (editable) {
    return (
      <div className="flex items-center gap-2">
        <Tooltip title={tooltipContent}>
          <label
            htmlFor="query-shortest"
            className="text-chariot-text-secondary text-sm"
          >
            N-Shortest:
          </label>
        </Tooltip>
        <input
          id="query-shortest"
          type="number"
          min="1"
          value={value ?? ''}
          onChange={onChange}
          className="bg-chariot-background-secondary text-chariot-text-primary border-chariot-stroke focus:border-chariot-brand-primary w-16 rounded-md border px-2 py-1 text-sm outline-none"
          data-testid="query-header-shortest-input"
        />
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <Tooltip title={tooltipContent}>
        <span className="text-chariot-text-secondary text-sm">
          Shortest Path:
        </span>
      </Tooltip>
      <span className="text-chariot-text-primary text-sm">
        {value !== undefined
          ? `${value} Hop${value !== 1 ? 's' : ''}`
          : '(none)'}
      </span>
    </div>
  );
}
